import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import WithMainContainer from "../../HOC/withMainContainer/WithMainContainer.HOC";
import Fixed from "../../containers/fixed/fixed.container";
import AlllReqs from "../alllReqs/alllReqs.component";
import SingleReq from "../singleReq/singleReq.component";
import { AppStyled } from "./noLogginHome.styles";
import { ThemeProvider } from "styled-components";
import theme from "../../styledTheme/styledTheme";
import useMediaQuery from "../../hooks/useMediaQuery";
import { setReqsTab } from "../../redux/reqs/reqs.actions";
import { useDispatch, useSelector } from "react-redux";
import { socketServer } from "../../assets/socketConnection";
import { fetchCurrentCardBitsSuccess } from "../../redux/currentReq/currentReq.actions";
import { selectCurrentReqInfo } from "../../redux/currentReq/currentReq.selectors";
const NoLogginHome = () => {
  let size = useMediaQuery();
  const AllReqsWithMainContainer = WithMainContainer(AlllReqs);
  const SingleReqWithMainContainer = WithMainContainer(SingleReq);
  const dispatch = useDispatch();
  useEffect(() => {
    // effect
    dispatch(setReqsTab(1));
  }, []);

  return (
    <ThemeProvider theme={{ ...theme, windowWidth: size }}>
      <AppStyled className="App">
        <Fixed />
        {!window.location.pathname.includes("BRN") ? (
          <AllReqsWithMainContainer />
        ) : (
          ""
        )}

        <Switch>
          <Route
            exact
            path="/app2/without/:id"
            render={() => <SingleReqWithMainContainer />}
          />
        </Switch>
      </AppStyled>
    </ThemeProvider>
  );
};

export default NoLogginHome;
